import React from "react";
import ReactDateTime from "react-datetime";
import {
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import "react-datetime/css/react-datetime.css";

export function DatePicker({
  value,
  onChange,
  viewMode = "days",
  isValidDate,
  maxWidth = true,
}) {
  return (
    <FormGroup
      style={{
        maxWidth: maxWidth ? "350px" : "none",
        width: "100%",
      }}
    >
      <InputGroup className="input-group-alternative">
        <InputGroupAddon addonType="prepend">
          <InputGroupText>
            <i className="ni ni-calendar-grid-58" />
          </InputGroupText>
        </InputGroupAddon>
        <ReactDateTime
          inputProps={{
            placeholder: "Insira uma data ...",
          }}
          dateFormat={viewMode === "months" ? "MM/YYYY" : "DD/MM/YYYY"}
          timeFormat={false}
          value={value}
          onChange={onChange}
          viewMode={viewMode}
          isValidDate={isValidDate}
        />
      </InputGroup>
    </FormGroup>
  );
}
